import { FC } from 'react';

import { Box, Drawer, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import ReportProblem from '@/shared/ui/icons/ReportProblem.svg';

import { TRole } from '@/shared/types/role';

import { ROUTES } from '@/shared/constants';

import { LogoutButton } from '@/features/auth';

import { getNavItems } from '../model/getNavItems';
import { Logo } from './Logo';
import { NavActionItem } from './NavActionItem';
import { NavItems } from './NavItems';

interface IProps {
  open: boolean;
  onClose: () => void;
  role: TRole;
  onReportProblem: () => void;
}

/**
 * Off-canvas мобильное меню (выезжает по burger).
 * @param root0 Пропсы
 * @param root0.open Открыт ли Drawer
 * @param root0.onClose Закрытие Drawer
 * @param root0.role Роль пользователя
 * @param root0.onReportProblem Запуск флоу «Сообщить о проблеме»
 */
export const MobileNavDrawer: FC<IProps> = ({
  open,
  onClose,
  role,
  onReportProblem
}) => {
  const navigate = useNavigate();
  const navItems = getNavItems(role);

  /**
   * Переход на главную и закрытие меню по тапу на логотип
   */
  const handleLogoClick = () => {
    navigate(ROUTES.root);
    onClose();
  };

  return (
    <Drawer
      anchor='left'
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            // 300, а не 280: label пункта позиционирован left: 64 / right: 20,
            // и «Сообщить о проблеме» в 280px не влезает целиком
            width: 300,
            background: `linear-gradient(135deg, #242269 0%, #121533 25.5%, #121533 75%, #112d7a 100%)`,
            py: 6,
            justifyContent: 'space-between',
            // Тач-таргет ряда меню ≥48px (только в мобильном Drawer — десктоп-рельса
            // рендерит те же NavItem, но её не трогаем).
            '& .MuiListItem-root': { minHeight: 48 }
          }
        }
      }}
    >
      {/* Любой клик внутри списка (переход по пункту) закрывает Drawer */}
      <Box onClick={onClose} sx={{ width: '100%' }}>
        <Box
          role='button'
          aria-label='На главную'
          onClick={handleLogoClick}
          sx={{ px: 4, mb: 4, cursor: 'pointer' }}
        >
          <Logo isExpanded isVisible />
        </Box>
        <NavItems
          items={navItems}
          isExpanded
          actionSlot={
            <NavActionItem
              Icon={ReportProblem}
              label='Сообщить о проблеме'
              isExpanded
              onClick={onReportProblem}
            />
          }
        />
      </Box>
      <Stack sx={{ width: '100%', px: 4 }}>
        <LogoutButton widthText />
      </Stack>
    </Drawer>
  );
};
